<template>
    <div>
        <Row>
            <Col class="form_left">
                <div class="sus"><span></span></div>
                <p>恭喜！已成功导入<i>{{successCount}}</i>条书目数据！</p>
            </Col>
        </Row>
        <Row>
            <Col class="button_box">
                <Button type="primary" @click="btnReturn">返回上传</Button>
            </Col>
        </Row>
    </div>
</template>

<script>
import {Row, Col, Button} from 'element-ui'
    export default {
        data(){
            return{
                // title:''
            }     
        },
        props: ['successCount','uploadType'],
        components:{
            Row, Col, Button
        },
        created(){
        	let vm=this;
        },
        methods: {
            btnReturn() {
                let vm = this;
//              if(vm.uploadType == 'library'){//馆藏
//              	vm.$emit('back',false);
//              }else{//清单
//              	
//              }
				vm.$emit('back',false);
            },
        },
        mounted(){
        },
    };
</script>

<style lang='scss'>
    // @import "src/style/common";
    .form_left{
        margin-top: 30px;
        .sus{
            text-align: center;
            span{
                display: inline-block;
                width:50px;
                height: 50px;
                background: url("/images/icon.png") no-repeat;
                background-position: -5px -53px;
            }
        }
        p{
            font-size: 12px;
            text-align: center;
            margin-top: 30px;
            font-weight: bold;
            i{
                color: #ff0000;
            }
            &.remark{
                margin-top: 10px;
                font-size: 12px;
                font-weight: normal;
                i{
                    color:#333;
                }
                .import{
                    color: #145db7;
                    text-decoration: underline;
                }
            }
        }
    }
    .button_box{
        text-align: center;
        margin-top: 30px !important;
    }
    
    
</style>



// WEBPACK FOOTER //
// src/views/importOrder/Successful.vue